import { Trophy, Star } from "lucide-react";

// URL officielle de vote Emergent Concours Mondial — configurable via .env
const VOTE_URL = process.env.REACT_APP_VOTE_URL || "https://emergent.sh/vote";

const trackVoteClick = () => {
  // Fire-and-forget analytics + laisse le navigateur suivre le lien
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/analytics/track`, {
      method: "POST", credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ event: "click_vote" }),
      keepalive: true,
    });
  } catch (e) { console.warn("Vote beacon failed:", e); }
};

export function VoteBanner() {
  return (
    <div className="vote-banner" data-testid="vote-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-11 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <Trophy className="w-4 h-4 text-[#FFD35A] flex-shrink-0" />
          <span className="text-xs sm:text-sm font-semibold truncate">
            <span className="hidden sm:inline">🏆 JurisFlash participe au Concours Mondial Emergent —</span>
            <span className="sm:hidden">🏆 Concours Emergent —</span>
            {" "}Testez et votez.
          </span>
        </div>
        <a
          href={VOTE_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={trackVoteClick}
          className="vote-cta flex-shrink-0"
          data-testid="vote-cta-btn"
        >
          <Star className="w-3.5 h-3.5" />
          <span className="hidden sm:inline">Voter en 1 clic via Google</span>
          <span className="sm:hidden">Voter</span>
        </a>
      </div>
    </div>
  );
}
